import { render, staticRenderFns } from "./SolicitacaoMovimentacaoList.vue?vue&type=template&id=7ae67820"
import script from "./SolicitacaoMovimentacaoList.vue?vue&type=script&lang=js"
export * from "./SolicitacaoMovimentacaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports